import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import IsOrderFilter from '../../../components/filters/isOrderFilter';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';


import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';

import Select from 'react-select';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";

import { DataContext } from '../../../init/getData';
import e from 'cors';




function LowInStock(props) {

  let { type } = props;


  const { api, userData, settingData, categoryOptions, refData, selectedCompany, wareHouseOptions, contentLanguages } = useContext(DataContext);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;
  const userRole = userData.role;
  const companyId = selectedCompany.id;
  const defaultwarehouseId = userData.role.warehouseId;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [lowInStock, setLowInStock] = useState('');

  const table = 'lowInStock';
  const title = 'Low In Stock';


  const [idRow, setIdRow] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', companyId });


  const [showCartModal, setShowCartModal] = useState(false);

  const [transaction, setTransaction] = useState(false);


  //Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['warehouse']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data, getSummary) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        barcode: item.barcode,
        category: item.category?.name,
        name: item.name,
        lowInStock: item.lowInStock,
        totalStock: item.totalStock,
        cost: item.cost,
        price: item.price,
        type: item.type,
        unit: item.unit,
      };

      transformedData.push(newItem);
    });



    return { transformedData };
  };


  let newColumnDefs = [
    { title: contentLanguages.ID, dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.barcode, dataIndex: 'barcode' },
    { title: contentLanguages.Category, dataIndex: 'category', render: (category) => (category?.name) },
    { title: contentLanguages.Name, dataIndex: 'name' },
    { title: contentLanguages.LowInStock, dataIndex: 'lowInStock' },
    { title: contentLanguages.Stock, dataIndex: 'quantity', render: (quantity, record) => (numberFormatter(quantity, 2) + ' ' + record.unit) },
    { title: contentLanguages.Cost, dataIndex: 'cost', width: '8%', render: numberFormatter },
    { title: contentLanguages.Price, dataIndex: 'price', width: '8%', render: numberFormatter },
    { title: contentLanguages.Type, dataIndex: 'type' },
  ];

  useEffect(() => {
    setColumnDefs(newColumnDefs);
  }, [filter.isActive]);


  const formView = '';


  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '35%', transform: 'translateX(-50%)' }}>

    </div>

  );



  const modalFooter = (
    <div style={{ textAllign: 'center' }}>

      {/* Total */}
      <Row className="mb-3" style={{ marginTop: '2%', justifyContent: 'center' }}>
        <Form.Group as={Col} style={{ display: 'flex', justifyContent: 'center' }}>
          <Form.Label></Form.Label>

        </Form.Group>
      </Row>
    </div>
  )



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };

  const handleLowInStock = (e) => {
    if (e.key === 'Enter') {
      setFilter(prevFilter => ({ ...prevFilter, lowInStock: e.target.value }));
    }
  };


  const handleLowInStockChange = (e) => {
    setFilter(prevFilter => ({ ...prevFilter, lowInStock: e.target.value }));
  };



  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                isSearchable={true}
                isClearable={true}
                onChange={(e) => handleSelectChange(e, 'categoryId')}
                value={categoryOptions?.find(option => option.value === filter.categoryId) || []}
                placeholder={'Select Category... '}
                required
              />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={wareHouseOptions}
                isSearchable={true}
                isClearable={true}
                onChange={(e) => handleSelectChange(e, 'warehouseId')}
                value={wareHouseOptions?.find(option => option.value === filter.warehouseId) || []}
                placeholder={'Select Warehouse... '}
                required
              />
            </Col>

            <Col md={2}>
              <Form.Control type="number" size="sm" placeholder="Under This Number ..."
                onChange={(e) => handleLowInStockChange(e)}
              >
              </Form.Control>
            </Col>

            <Col md={2}>

              <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                <FiFilter size={15} color='white' />
              </Button>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>

          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            height={true}
            selection={true}
            refreshTable={refreshTable}
          />



        </>
      }

    </div>
  )
}

export default LowInStock;
